<template v-if="product">
  <div
    v-if="category.ProductID"
    class="item"
    style="cursor: pointer"
    @click="showModal"
    :style="getRolldProductStyles()"
  >
    <div
      :class="{ 'with-image': getProductImage(product) }"
      class="item-details"
    >
      <h5 class="item-title">{{ getProductName() }}</h5>
      <p
        :title="product.ShortDescription"
        class="block-with-text"
        v-html="getProductDescription()"
      ></p>
    </div>
    <div class="item-price d-flex">
      <h5>
        <template v-if="!priceOverride">
          {{ category.Price | formatMoney(currencySign) }}
        </template>
        <template v-else>
          <del>{{ category.Price | formatMoney(currencySign) }}</del>
          <span>{{ priceOverride | formatMoney(currencySign) }}</span>
        </template>
      </h5>
      <ul>
        <li
          v-for="(dietary, index) in dietaryList"
          :key="index"
          :style="getIconStyle(dietary)"
          :title="dietary.Name"
        ></li>
      </ul>
    </div>
    <div class="item-rolld-addToCard text-red" v-if="isRolldStore()">
      Add to cart >
    </div>
    <div
      v-lazy:background-image="getProductImage(product)"
      :style="imageRatioStyle"
      class="item-img"
    />
    <img
      v-lazy="getProductImage(product)"
      style="display: none"
      class="item-img"
      @error="imgHttpError"
      alt="productImage"
    />
    <div
      v-if="status === undefined"
      :class="{
        new: product.Status === 1,
        popular: product.Status === 2,
        sold: product.Status === 3,
      }"
      class="ibadge"
      :style="getRolldProductStyles(product.Status === 3, true)"
    >
      {{ formatStatus(product.Status, this) }}
    </div>
    <div
      v-else
      :class="{
        new: status === 1,
        popular: status === 2,
        sold: status === 3,
      }"
      class="ibadge"
      :style="getRolldProductStyles(status === 3, true)"
    >
      {{ formatStatus(status, this) }}
    </div>
    <AddToCart
      v-if="isModalVisible"
      :price="category.Price"
      :category="category"
      :parent-category="parentCategory"
      :product="product"
      :modifiers="modifiers"
      :image-styles="dialogImageRatioStyle"
      :product-id="category.ProductID"
    />
  </div>
</template>

<script>
import shared from "../../../sharedscripts/shop/products/Product.js";
import AddToCart from "./AddToCart.vue";
import { mapGetters } from "vuex";
import { AppConfig } from "../../../../AppConfig";
import sharedTranslations from "@/sharedscripts/shop/products/Translations";
export default {
  name: "Product",
  components: {
    AddToCart,
  },
  filters: {
    ...shared.filters,
  },
  props: {
    product: {
      type: Object,
      default: () => {},
    },
    category: {
      type: Object,
      default: () => {},
    },
    parentCategory: {
      type: Object,
      default: () => {},
    },
    modifiers: {
      type: Object,
      default: () => {},
    },
    sectionId: {
      type: Number,
      default: 0,
    },
    status: {
      type: Number,
    },
  },
  data() {
    return {
      isModalVisible: false,
      width: 0,
      height: 0,
    };
  },
  computed: {
    ...mapGetters(["desktopStyles"]),
    ...shared.computed,
  },
  mounted() {
    this.getImageWidthHeight();
  },
  methods: {
    ...shared.methods,
    ...sharedTranslations.methods,
    imgHttpError(event) {
      if (event && event.target && event.target.style)
        event.target.style.display = "none";
    },
    formatStatus(value, vueObj) {
      let that = vueObj;
      let pricing;
      switch (value) {
        case 1:
          pricing = that.$t("message.new");
          break;
        case 2:
          pricing = that.$t("message.popular");
          break;
        case 3:
          pricing = that.$t("message.soldOut");
          break;
        default:
          pricing = "";
          break;
      }
      return pricing;
    },
    getProductImage(product) {
      if (!this.isRolldStore()) {
        if (product.PhotoUrl) return product.PhotoUrl;
        else return null;
      } else {
        return `https://firebasestorage.googleapis.com/v0/b/${AppConfig.firebaseProjectId}.appspot.com/o/Photos%2F${product.ProductCode}.jpg?alt=media&token=adc34ed7-644d-45b0-a617-1f88e8024243`;
      }
    },
    getRolldProductStyles(effect = true, soldout = false) {
      var styles = [];
      if (!this.isRolldStore()) {
        styles.push(this.desktopStyles.textColour);
      }
      if (this.isRolldStore() && effect) {
        styles.push({ "background-color": "unset" });
        styles.push({ "box-shadow": "unset" });
        styles.push({ height: soldout ? "100%" : "85%" });
      }
      return styles;
    },
  },
};
</script>
